<template>
  <div v-if="this.surveyId" class="questionario-container">
    <div class="col-xs-3 col-xs-offset-5">
      <div id="loadbar" style="display: none">
        <div class="blockG" id="rotateG_01"></div>
        <div class="blockG" id="rotateG_02"></div>
        <div class="blockG" id="rotateG_03"></div>
        <div class="blockG" id="rotateG_04"></div>
        <div class="blockG" id="rotateG_05"></div>
        <div class="blockG" id="rotateG_06"></div>
        <div class="blockG" id="rotateG_07"></div>
        <div class="blockG" id="rotateG_08"></div>
      </div>
    </div>
    <div class="row w-100" v-if="html_content">
      <div class="col-12">
        <div v-html="html_content" class="article_container"></div>
      </div>
    </div>
    <div class="row w-100">
      <div class="col-12" align="center">
        <div
          v-if="showErroreGenerico"
          class="alert alert-danger alert-dismissible"
          role="alert"
        >
          <strong>Attenzione</strong> Si è verificato un errore, prova ad iniziare un nuovo questionario per favore.
        </div>
        <div v-else class="domanda-e-risposte">
          <h2 class="domanda-questionario">
            <span class="label label-success" id="qid" v-html="this.question"></span>
          </h2>
          <hr />
          <div class="quiz" id="quiz" data-toggle="buttons">
            <form id="survey" method="post">
              <div v-for="(answer, index) in answers" :key="answer.id">
                <risposta
                  :className="this.getRispostaClassName(index)"
                  :answerData="answer"
                  :text="answer.text"
                  :rispostaId="answer.rispostaId"
                  :onClickCallback="
                    answer.onClickCallback || this.getNextQuestionByAnswer
                  "
                />
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <button
              v-if="
                this.answerHistory.length > 0 &&
                paginaLoader !== true &&
                !this.paginaRingraziamentoAperta &&
                !this.showErroreGenerico
              "
              :onclick="this.indietroClick"
              class="domanda-precedente float-start btn btn-lg pull-left col-xs-12 col-lg-5"
            >
              <span class="bi-chevron-left"></span
              >{{ intl[$store.state.lang]["go-back"] }}
            </button>
          </div>
          <div v-if="this.questionId != 1 || showErroreGenerico" class="col-md-6">
            <button
              :onclick="this.restartQuiz"
              class="nuovo-questionario float-end btn btn-danger btn-lg pull-right col-lg-6 col-xs-12"
            >
              <span class="bi-arrow-clockwise"></span
              >{{ intl[$store.state.lang]["new-quiz"] }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import Risposta from "../risposta/Risposta.vue";
import { apiUrls } from "../../api/apiUrls";
import { formatDate } from "../../api/apiUtils";
import questionarioStore from "./store/index";
import { mapState } from "vuex";
export default {
  name: "questionario",
  components: {
    risposta: Risposta,
  },
  props: {
    paginaRingraziamentoAperta: {
      type: Boolean,
      default: false,
    },
    paginaLoader: {
      type: Boolean,
      default: null,
    },
    surveyId: {
      type: Number,
      default: null,
    },
    saveAnswerHistoryMode: {
      type: Boolean,
      default: process.env.VUE_APP_RICORDA_RISPOSTE_QUESTIONARIO === "true",
    },

    rispostaTerminaleCallback: {
      type: Function,
      default: (response, answerInfo) => {
        console.log("Risposta terminale: ", answerInfo);
      },
    },
    rispostaCallback: {
      type: Function,
      default: (answerInfo) => {
        console.log("Risposta non terminale: ", answerInfo);
      },
    },
    onIndietroClickCallback: {
      type: Function,
      default: () => {
        console.log("Click su indietro");
      },
    },
    onRicominciaQuestionarioClickCallback: {
      type: Function,
      default: () => {
        console.log("Click su ricomincia questionario");
      },
    },
    rispostaFinaleCallback: {
      type: Function,
      default: (type) => {
        console.log("Risposta finale: ");
      },
    },
    setPaginaLoaderCallback: {
      type: Function,
      default: (value) => {
        console.log("Pagina loader callback : ", value);
      },
    },
    onCreateSurveyLogCallback: {
      type: Function,
      default: (response) => {
        console.log("Create survey log callback: ", response);
      },
    },
  },

  created() {
    let mustCreateNewSurveyLog = !this.$store.getters.getSurveyLogId

    if (this.surveyId && !this.saveAnswerHistoryMode) {
      this.createSurveyLogAndShowInitialQuestion();
    } else {
      if (this.saveAnswerHistoryMode) {
        if (this.surveyId && mustCreateNewSurveyLog) {
          this.createSurveyLogAndShowInitialQuestion();
        } else {
          this.startFromExistingSurveyLog();
        }
      }
    }
  },
  beforeMount() {
    this.$store.registerModule(
      "questionarioStore-" + this.surveyId,
      questionarioStore
    );
  },

  data: function () {
    return {
      intl: intl,
      answers: [],
      question: "",
      questionId: null,
      answerHistory: [],
      quizLoader: false,
      lastSurveyLogId: null,
      html_content: "",
      confermaTicketFeedback: {
        show: false,
        type: '', // success o error
        message: ""
      }
    };
  },
  methods: {

    addFakeAnswer() {
      this.answerHistory.push({ answerId: "fake-answer" });
    },
    startFromExistingSurveyLog() {
      let surveyLogId = this.$store.getters.getSurveyLogId
      let getQuestionLogDetailPromise = axios.get(
        apiUrls["survey_log_detail"] + surveyLogId
      );
      let answerHistory = [];
      this.quizLoader = true;
      getQuestionLogDetailPromise
        .then((response) => {
          if (response.data && response.data.question_done) {
            if(response.data.finished === 1){
              this.$store.dispatch("DELETE_SURVEY_LOG");
              this.createSurveyLogAndShowInitialQuestion()
            } else if (response.data.question_done.length > 0) {
              response.data.question_done.map((logDone, index) => {
                answerHistory.push({
                  answerId: logDone.id_answer,
                  logDoneId: logDone.id,
                });
                this.lastSurveyLogId = logDone["id_survey_log"];
              });
              this.answerHistory = answerHistory;
              this.getNextQuestionByAnswer(
                {
                  id: this.answerHistory[this.answerHistory.length - 1]
                    .answerId,
                },
                false
              );
            } else {
              //caso in cui si è tornati alla prima pagina non essendoci risposte nel log_done
              this.lastSurveyLogId = surveyLogId;
              this.getNextQuestionByAnswer({ id: 0 }, false);
            }
          } else {
            this.quizLoader = false;
          }
        })
        .catch((error) => {
          this.quizLoader = false;
        });
    },
        //QUESTO METODO MOSTRA LA PRIMA DOMANDA DEL QUESTIONARIO E GENERA IL SURVEY LOG
    //SE VIENE FORZATA DALL'ESTERNO UNA ANSWER ID PASSANDO AL CLIENT startFromAnswerId ALLORA PARTE DA QUELLA RISPOSTA
     createSurveyLogAndShowInitialQuestion() {
      let getStartingQuestionPromise = null
      const params = new URLSearchParams(window.location.search);
      const isGeam = params.get('isGeam');
      if(this.$store.state["libraryWiperConfig"].startFromAnswerId && isGeam == 'true'){
        getStartingQuestionPromise = axios.get(
          apiUrls["user_survey"] + this.surveyId + "/" + this.$store.state["libraryWiperConfig"].startFromAnswerId
        );
      }else { 
        getStartingQuestionPromise = axios.get(
          apiUrls["user_survey"] + this.surveyId + "/0"
          );
      }
      
      let createSurveylogPromise = axios.post(apiUrls["create_survey_log"], {
        id_survey: this.surveyId,
        finished: 0,
        started: formatDate(new Date()),
      });
      this.quizLoader = true;
      this.question = "";
      getStartingQuestionPromise
        .then((response) => {
          if (response.data && response.data.answer) {
            this.answers = response.data.answer;
          }
          if (response.data && response.data.text) {
            this.question = response.data.text;
            this.questionId = response.data.id;
          }

          this.html_content = response.data.article_content;

          createSurveylogPromise
            .then((response) => {
              if (response.data && response.data.id) {
                this.lastSurveyLogId = response.data.id;
                this.$store.dispatch("SAVE_SURVEY_LOG", response.data.id);
              }
              this.quizLoader = false;
              const params = new URLSearchParams(window.location.search);
              const isGeam = params.get('isGeam');
              if(this.$store.state["libraryWiperConfig"].startFromAnswerId && isGeam == 'true'){
                this.getNextQuestionByAnswer(
                {
                  id: this.$store.state["libraryWiperConfig"].startFromAnswerId,
                },
                false
              );
              }
              this.onCreateSurveyLogCallback(response);
            })
            .catch((error) => {
              this.quizLoader = false;
            });
        })
        .catch((error) => {
          this.quizLoader = false;
        });
    }, 
    /* createSurveyLogAndShowInitialQuestion() {
      let getStartingQuestionPromise = axios.get(
        apiUrls["user_survey"] + this.surveyId + "/0"
      );
      let createSurveylogPromise = axios.post(apiUrls["create_survey_log"], {
        id_survey: this.surveyId,
        finished: 0,
        started: formatDate(new Date()),
      });
      this.quizLoader = true;
      this.question = "";
      getStartingQuestionPromise
        .then((response) => {
          if (response.data && response.data.answer) {
            this.answers = response.data.answer;
          }
          if (response.data && response.data.text) {
            this.question = response.data.text;
            this.questionId = response.data.id;
          }

          this.html_content = response.data.article_content;

          createSurveylogPromise
            .then((response) => {
              if (response.data && response.data.id) {
                this.lastSurveyLogId = response.data.id;
                this.$store.dispatch("SAVE_SURVEY_LOG", response.data.id);
              }
              this.quizLoader = false;
              this.onCreateSurveyLogCallback(response);
            })
            .catch((error) => {
              this.quizLoader = false;
            });
        })
        .catch((error) => {
          this.quizLoader = false;
        });
    }, */
    restartQuiz() {
      var answer = null
      var lastSurveyId = this.$store.getters.getSurveyLogId
      if(this.paginaRingraziamentoAperta || this.showErroreGenerico){
        answer = true
      }else{
        answer = window.confirm(
        "Le risposte fornite nel questionario attuale andranno perse"
      );
      }
      
      if(answer &&  (!lastSurveyId || !this.lastSurveyLogId)){
          this.createSurveyLogAndShowInitialQuestion();
          this.onRicominciaQuestionarioClickCallback();
        }

      else if (
        answer &&
        lastSurveyId
      ) {

        this.quizLoader = true;
        axios
          .put(apiUrls["edit_survey_log"] + this.lastSurveyLogId, {
            finished: 1,
          })
          .then((response) => {
            this.answerHistory = [];
            this.lastSurveyLogId = null;
            this.questionId = null;
            if(this.showErroreGenerico){
              this.$store.dispatch("HIDE_ERRORE_GENERICO");
            }
            this.$store.dispatch("DELETE_SURVEY_LOG");


            this.createSurveyLogAndShowInitialQuestion();
            this.onRicominciaQuestionarioClickCallback();
          })
          .catch((error) => {
            this.quizLoader = false;
            this.$store.dispatch("DELETE_SURVEY_LOG");
            this.createSurveyLogAndShowInitialQuestion();
            this.onRicominciaQuestionarioClickCallback();
          });
      } else {
        /* this.createSurveyLogAndShowInitialQuestion();
        this.onRicominciaQuestionarioClickCallback(); */
      }
    },
    async closeSurveyLog(createNewSurveyLog) {
      await axios
        .put(apiUrls["edit_survey_log"] + this.lastSurveyLogId, { finished: 1 })
        .then((response) => {
          this.answerHistory = [];
          this.lastSurveyLogId = null;
          this.questionId = null;
          this.saveAnswerHistoryMode &&
          this.$store.dispatch("DELETE_SURVEY_LOG");
          createNewSurveyLog
            ? this.createSurveyLogAndShowInitialQuestion()
            : (this.quizLoader = false);
        })
        .catch((error) => {
          this.quizLoader = false;
        });
    },
    getRispostaClassName(index) {
      index++;
      return "element-animation" + index + " btn btn-lg btn-block";
    },

    indietroClick() {
      this.onIndietroClickCallback();
      this.getPrevQuestionByAnswer();
    },

    getPrevQuestionByAnswer() {
      if (this.answerHistory.length > 0) {
        this.quizLoader = true;
        let answerId = 0;

        if (this.answerHistory.length > 1) {
          answerId = this.answerHistory[this.answerHistory.length - 2].answerId;
        }

        axios
          .get("user_survey/" + this.surveyId + "/" + answerId)
          .then((response) => {
            if (response.data && response.data.answer) {
              this.answers = response.data.answer;
            }
            if (response.data && response.data.text) {
              this.question = response.data.text;
              this.questionId = response.data.id;
            }
            if (this.answerHistory.length > 0) {
              if (
                this.answerHistory[this.answerHistory.length - 1].answerId ===
                "fake-answer"
              ) {
                this.answerHistory.pop();
                if (Object.keys(response.data).length === 0) {
                  this.rispostaTerminaleCallback(response, { id: answerId });
                }
                this.quizLoader = false;
              } else {
                axios
                  .delete(
                    apiUrls["delete_question_done"] +
                      this.answerHistory[this.answerHistory.length - 1]
                        .logDoneId
                  )
                  .then((response) => {
                    this.rispostaCallback(response, { id: answerId });
                    this.answerHistory.pop();
                    this.quizLoader = false;
                  })
                  .catch((error) => {
                    this.quizLoader = false;
                  });
              }
            }

            this.html_content = response.data.article_content;
          })
          .catch((error) => {
            this.quizLoader = false;
          });
      }
    },

    async getAnswerDetail(answerId) {

        let responseData = null
        await axios
          .get(apiUrls["answer_detail"] + answerId)
          .then((response) => {

            if(response?.data){
              responseData =  response.data
            }
            

          })
          .catch((error) => {
            
          });
          return responseData
      
    },

    async getNextQuestionByAnswer(answerData, saveLogDone) {
      this.quizLoader = true;
      let questionId = this.questionId;
      let getNextQuestion = () => {
        axios
          .get("user_survey/" + this.surveyId + "/" + answerData.id)
          .then(async (response) => {
            if (Object.keys(response.data).length === 0) {
              //wiper-pt ì: controllo se la risposta terminale ha documenti collegati o se ha answer no ticket
              let answerDetailResponse = await this.getAnswerDetail(answerData.id);
              this.rispostaTerminaleCallback(answerDetailResponse, answerData);
              if(answerDetailResponse?.answerNoTicket?.length  > 0 ){
                this.question = '';
                this.answers = [];
              }
              else if(answerDetailResponse?.answerFaq?.length > 0 || answerDetailResponse?.answerResource?.length > 0 || answerDetailResponse?.answerTag?.length > 0){
                let lastQuestionAndAnswer = this.getLastQuestionAndAnswer();
                this.question = lastQuestionAndAnswer.question;
                this.answers = lastQuestionAndAnswer.answers;
              }
              
            } else {

              if (response.data && response.data.answer) {
                this.answers = response.data.answer;
              }
              if (response.data && response.data.text) {
                this.question = response.data.text;
                this.questionId = response.data.id;
              }

              this.html_content = response.data.article_content;
              this.rispostaCallback(response, answerData);
            }

            this.quizLoader = false;
          })
          .catch((error) => {
            this.rispostaCallback(error, answerData);
            this.quizLoader = false;
          });
      };

      if (saveLogDone) {
        axios
          .post(apiUrls["create_question_done"], {
            id_survey_log: this.lastSurveyLogId,
            id_question: questionId,
            id_answer: answerData.id,
          })
          .then((response) => {
            this.answerHistory.push({
              answerId: answerData.id,
              logDoneId: response.data.id,
            });
            getNextQuestion();
          })
          .catch((error) => {});
      } else {
        getNextQuestion();
      }
    },

    getLastQuestionAndAnswer() {
      let questionarioId =
        this.$store.state["libraryWiperConfig"].questionarioId ||
        process.env.VUE_APP_QUESTIONARIO_ID;
      switch (questionarioId) {
        /*   case "ferretti":
                    return {
                        question: "Vuoi essere ricontattato?",
                        answers: [
                            {
                                rispostaId: "compilaform",
                                onClickCallback:() =>{
                                    this.answerHistory.push({answerId: "fake-answer"})
                                    this.rispostaFinaleCallback("ferretti-voglio-essere-contattato")
                                }
                            }]
                    } */

        default:
          return {
            question: "Hai trovato la risposta che cercavi?",
            answers: [
              {
                rispostaId: "yes",
                onClickCallback: () => {
                  this.addFakeAnswer();
                  this.rispostaFinaleCallback("wiper-assistenza-yes");
                },
              },
              {
                rispostaId: "no",
                onClickCallback: () => {
                  this.rispostaFinaleCallback("wiper-assistenza-no");
                },
              },
            ],
          };
      }
    },
  },
  watch: {
    quizLoader: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setPaginaLoaderCallback({ quizLoader: newValue });
        }
      },
      deep: true,
    },
    resetQuiz: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue && newValue === true) {
          this.closeSurveyLog(true);
          this.$store.commit(
            "questionarioStore-" + this.surveyId + "/doNotResetQuiz"
          );
        }
      },
      deep: true,
    },
    closeQuiz: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue && newValue === true) {
          this.closeSurveyLog();
          this.$store.commit(
            "questionarioStore-" + this.surveyId + "/doNotCloseQuiz"
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      resetQuiz(state) {
        if (state["questionarioStore-" + this.surveyId])
          return state["questionarioStore-" + this.surveyId].resetQuiz;
        //return this.$store.state["questionarioStore-"+this.surveyId].resetQuiz
      },
      closeQuiz(state) {
        if (state["questionarioStore-" + this.surveyId])
          return state["questionarioStore-" + this.surveyId].closeQuiz;
        //return this.$store.state["questionarioStore-"+this.surveyId].resetQuiz
      },
      showErroreGenerico(state) {
        return state["erroreGenericoApplicazione"];
      },
    }),
    imageRoot() {
      return process.env.VUE_APP_BASE_PATH;
    },
  },
  unmounted() {
    this.$store.unregisterModule("questionarioStore-" + this.surveyId);
  },
};
</script>
